import React, { useState, useRef, useCallback, useEffect, useLayoutEffect } from 'react';
import axios from 'axios';
import { useParams, useNavigate, useSearchParams } from 'react-router-dom'
import { format } from 'react-string-format';
import { useTranslation } from 'react-i18next';
import Button from '../../UI/Buttons/Button';
import '../../../i18n';
import * as ReactDOM from 'react-dom';
import ErrorBoxCS from '../../UI/ErrorBox/ErrorBox';
import { GetConfiguration, GetCurrentBrand } from '../../Configuration/ConfigurationManager';
import { APIGet, APIPost, APIRedirect } from '../../API/APIRequest'
import { ErrorBox, ProcessErrors } from '../../Utilities/ErrorBox';
import { LogWebActivity } from '../../Webactivity/LogWebActivity';
import { Loading } from '../../Utilities/Loading';
import { IsSafeUrl, RedirectWarning } from '../../Utilities/SafeUrl';
import { useAuth } from '../AuthenticationProvider';
import Input from '../../UI/Inputs/Input';
import InputWrapper from '../../UI/Inputs/InputWrapper';
import Checkbox from '../../UI/Checkbox/Checkbox';
import useBodyClass from '../../../Hooks/useBodyClass';
import usePageTitle from '../../../Hooks/usePageTitle';
import ReactHtmlParser from 'html-react-parser';
import './Register.css';
import { Password } from '../PasswordValidations/PasswordValidations';
import InputWrapperRefacture from '../../UI/Inputs/InputWrapperRefacture';
import useCreateUrl from '../../../Hooks/useCreateUrl';
import { GenericErrorBox } from '../../UI/ErrorBox/GenericErrorBox';
import setStateAsync from '../../Utilities/SetStateAsync';
import useBrandingData from '../../../Hooks/useBrandingData';
import { emailRegexUtils, nameRegexUtils } from '../../Utilities/EmailRegex';
import { isCheckoutJourney, isActivationJourney } from '../../Utilities/JourneyDetection';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
  } from 'react-google-recaptcha-v3';
import { APIUrl } from '../../Utilities/APIUrl';
import { RecaptchaError } from '../../Utilities/RecaptchaError';
import Transition from '../../UI/Transition/Transition';
import DOMPurify from 'dompurify';
import SurveyForm, { FormStepIndicator } from 'ad-web-ui-library';
  

export function Register(props) {

    useBodyClass(['register', props.brandingElement?.bodyClass]);
    usePageTitle(`Create your account - ${props.brandingElement?.id}`);

    const { t, i18n } = useTranslation();
    const [errors, setErrors] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [checking, setChecking] = useState(false);
    const [isNotTrusted, setIsNotTrusted] = useState('');
    const { environment } = useParams();
    const auth = useAuth();
    const [fieldChanged, setFieldChanged] = useState(null);
    const [firstName, setFirstName] = useState("");
    const [buttonEvent, setButtonEvent] = useState(false);
    const [lastName, setLastName] = useState("");
    const [dpa, setDpa] = useState([]);
    const [cleanDpaQuestionHtml, setCleanDpaQuestionHtml] = useState([]);
    const [userPassword, setUserPassword] = useState("");
    const [registered, setRegistered] = useState("false");
    const [userEmail, setUserEmail] = useState(localStorage.getItem('email'));
    const [pswValid, setPswValid] = useState("false");
    const [isChecked, setIsChecked] = useState("false")
    const [buttonState, setButtonState] = useState("initial");
    const [IsBlank, setIsBlank] = useState({ email: false, password: false, lastName: false, firstName: false, dpa: false })
    const [IsInvalid, setIsInvalid] = useState({ lastName: false, firstName: false})
    const createUrl = useCreateUrl();
    const navigate = useNavigate();
    const headerRef = useRef(null);
    const formRef=useRef(null);
    const [isDpaQuestionTextBlank, setIsDpaQuestionTextBlank] = useState(false);
    const [dpaValidationConfig , setDpaValidationConfig] = useState(false);
    // const { getBrandedHtml } = useBrandingData(props.brandingElement ? props.brandingElement : "");
    // const recaptchaKey=getBrandedHtml('reCAPTCHAkey')
    const [reCaptchaError, setReCaptchaError]= useState(false)
    const [surveyData, setSurveyData] = useState({});
    const emailRegex = emailRegexUtils;
    const nameRegex = nameRegexUtils;
    const surveyRef = useRef(null);
    const { executeRecaptcha } = useGoogleReCaptcha();

    // Multi-page demographics survey state. pageCount is learned from SurveyForm's onReady
    // (the shared component builds the model internally in Mode 2). pageCount <= 1 means a
    // single-page form, which renders exactly as it does today (no nav, Register shown
    // immediately). pageNumber is the 0-based current survey page.
    const [pageNumber, setPageNumber] = useState(0);
    const [pageCount, setPageCount] = useState(1);
    // PADD-3866: step-indicator state. errorStep flags a step in the error state when its
    // validation blocks NEXT; hasBranching hides the indicator entirely when the form uses
    // branching (a linear stepper would mislead users who skip pages).
    const [errorStep, setErrorStep] = useState(null);
    const [hasBranching, setHasBranching] = useState(false);
    // The demographics form's first-page title (admin-configured). On a multi-page form, if the
    // first page has a title it replaces the default "Create your account" heading. SurveyForm
    // surfaces it via onReady (captured before hideFirstPagePanel clears the page title).
    const [firstPageTitle, setFirstPageTitle] = useState('');
    // The first-page description (admin-configured). On a multi-page form it shows under the
    // heading as intro text. Also surfaced by SurveyForm via onReady before hideFirstPagePanel
    // clears the page description.
    const [firstPageDescription, setFirstPageDescription] = useState('');
    // True once SurveyForm's onReady has fired. When a survey is present we hold the heading
    // back until this flips true, so the admin-configured first-page title renders straight
    // away instead of briefly showing the default "Create your account" and then swapping.
    const [surveyReady, setSurveyReady] = useState(false);
    // Drives the survey's cascade reveal. The <SurveyForm> must stay mounted from the start to
    // fetch its JSON (that fetch flips surveyReady), so we can't gate its mount on surveyReady
    // the way the Transition-wrapped blocks are gated. Instead it renders hidden (mount-start:
    // opacity 0 / max-height 0, so it takes no space and is invisible but still transition-able),
    // and this flag flips true ~500ms AFTER surveyReady — matching the survey's ladder slot — to
    // trigger the opacity/height reveal. A CSS transition-delay doesn't work here because the
    // element starts hidden via class (not display:none) and the browser needs a real timer, not
    // a delay, to animate from the correct frame.
    const [surveyRevealed, setSurveyRevealed] = useState(false);
    const isMultiPage = pageCount > 1;
    const isLastSurveyPage = pageNumber >= pageCount - 1;

    // Trigger the survey reveal 700ms after the JSON reports ready, so it animates in after the
    // native fields (300/400) and before the DPA (600).
    useEffect(() => {
        if (!surveyReady) return;
        const timer = setTimeout(() => setSurveyRevealed(true), 500);
        return () => clearTimeout(timer);
    }, [surveyReady]);

    const [surveycode, setSurveyCode] = useState(null);
    let [searchParams] = useSearchParams();
    let campaignCodeParam = searchParams.get("campaigncode") || searchParams.get("campaignCode");
    // surveycode may be on the Register URL directly, or persisted by the login step
    // (the login->register navigate only carries ReturnUrl, so .../login?surveycode=123
    // stashes it in sessionStorage).
    let surveycodeURLParam = searchParams.get("surveycode") || sessionStorage.getItem("surveycode");
    // Friendly reg-form URL slug, persisted by the login step from /{env}/login/{slug}.
    let friendlyUrlParam = sessionStorage.getItem("friendlyUrlSlug");
    // Journey marker persisted by the login step (e.g. /{env}/login/activation).
    let persistedJourney = sessionStorage.getItem("journey");
    //recaptcha verification
    const handleReCaptchaVerify = useCallback(async () => {
        if (!executeRecaptcha) {
            console.log('Execute recaptcha not yet available');
            return;
        }try{

            const recaptchaToken = await executeRecaptcha('register');
            return recaptchaToken;

        } catch(err){
            //in case of invalid recaptcha key
            return "invalidKey";
        }
      
        // we will use the token in recaptchaVerified()
    }, [executeRecaptcha]);

 
    const ReturnUrl = () => {
        let params = (new URL(document.location)).searchParams;
        return params.get("ReturnUrl");
    }

    const loadDPA = async () => {
        await APIGet({
            "controller": "auth0",
            "action": "getregistrationdpa",
            "environment": environment
        })
            .then(function (response) {

                let dpa=response.data.dpaquestion;
                setDpa(dpa);
                cleanDpaText(dpa?.questiontext);
                checkForDpaQuestionText(dpa?.questiontext) //check for blank question text
                setIsChecked(dpa?.defaultticked); //this is also async..so may take time so directly pass in the function.
                setIsLoading(false)
                
            })
            .catch(function (error) {
                // handle error
                setIsLoading(false);
                console.log(error);
            })
    }

    const checkForDpaQuestionText=(dpa)=>{
       
        let div = document.createElement('div');
        
        div.innerHTML = dpa;
        
        let textContent = div.textContent;  
        
        let trimmedText = textContent.trim();   //if html is present and has a blank
        
        if(trimmedText===""){
            setIsDpaQuestionTextBlank(true);
        }

    }

    const cleanDpaText=(dpa)=>{
        const cleanDpaHtml = DOMPurify.sanitize(dpa, {
            ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'style'], // Add any other allowed attributes here
          });

        setCleanDpaQuestionHtml(cleanDpaHtml); 
    }


    useEffect(() => {

        setButtonState("initial");
        return () => {
        setButtonState("initial")     //when we leave the page it sets button state to initial
        };
    }, [window.location.href])

    useEffect(() => {
        loadDPA();
        getFrontendConfiguration();
        getCurrentBrandDefaultDemograpicsForm();
        headerRef.current?.focus();
    }, [])

    useLayoutEffect(() => {

        setTimeout(() => {
            if (localStorage.getItem("email")) {
                setUserEmail(localStorage.getItem("email"))
                auth.CheckRegisteredAccount(localStorage.getItem("email")).then((result) => {
                if (result.status === "email_found") {
                   setRegistered("true");
                 }
                }).catch((errors) => {

                });
            }
        }, 1500)
    }, [])

    //recaptcha verification
    const recaptchaVerified = async() => {
        const recaptchaToken = await handleReCaptchaVerify();
        //if recaptcha is incorrect
        if(recaptchaToken === "invalidKey"){
            return true;  //it should work without the recaptcha as well and will return true in case of invalid key
        }
           
           let bodyFormData = new FormData();
           bodyFormData.append('token', recaptchaToken);

           const res = await APIPost({
               "controller": "security",
               "action": "verifyrecaptcha",
               "environment" : environment,
               data: bodyFormData,
           }).catch((errors) => { ProcessErrors(errors)})

           if (res.data.success) {
               if (res.data.score > 0.5) {
                   return true;    //probable human activity
               }
               else{
                 setReCaptchaError(true)   //probabale bot activity
                 return false;
               } 
           }else{
               return false;
           }
        
    }

    const registerUser = async(event) => {
        event.preventDefault();

        // Enter-key / early-submit trap for multi-page demographics. The survey, native fields
        // and Register button all live in ONE native <form>, so pressing Enter in a text field
        // (or any stray submit) on a non-final survey page would otherwise register the user
        // before they've completed later pages — whose required questions are validated but not
        // visible. On a multi-page form that isn't on its last page, route the action to NEXT
        // instead of registering. Single-page forms are unaffected.
        if (isMultiPage && !isLastSurveyPage) {
            handleSurveyNext(event);
            return;
        }

       //in case of invalid key or of no-recaptcha value of isHuman will be true, only when we get a valid recaptchaKey, the flow of recaptcha
       //and assessment of activity will begin.
        //recaptcha verification
        let surveyData = null;
        if (surveyRef?.current) {
            surveyRef.current.prefixAnswers();
            surveyData = surveyRef.current.getSurveyData();
        
            
        }
        setButtonState("loading")  
        setErrors(null);
        if (Validated()) {
            const isHuman= props.hasRecaptcha ? await recaptchaVerified() : true; 

            if(isHuman){
                   
                let controller = "";               
                switch (auth.authProviderType) {
                    case "adnative":
                        controller = "account";
                        break;
                    case "auth0":
                        controller = "auth0";
                        break;
                }               
                     
                let returnUrl = auth.ReturnUrl();

                let bodyFormData = new FormData();
                let userName = userEmail;
                let password = userPassword;
                bodyFormData.append('email', userName);
                bodyFormData.append('password', password);
                bodyFormData.append('firstname', firstName);
                bodyFormData.append('surname', lastName);
                if (surveyData) {
                    for (let key in surveyData) {
                        bodyFormData.append(`_srvitem_${key}`, surveyData[key]);
                        console.log(bodyFormData)
                    }
                }
                // Capture boolean toggle switch values (custom renderer doesn't persist to survey.data correctly)
                if (surveyRef?.current?.getBooleanToggleValues) {
                    const toggleValues = surveyRef.current.getBooleanToggleValues();
                    
                    // Group toggle values by base question key (remove the trailing _optionCode suffix)
                    const groupedToggles = {};
                    for (let key in toggleValues) { 
                        const lastUnderscore = key.lastIndexOf('_');
                        const baseKey = key.substring(0, lastUnderscore);
                        const optionCode = toggleValues[key];
                        if (!groupedToggles[baseKey]) {
                            groupedToggles[baseKey] = [];
                        }
                        groupedToggles[baseKey].push(optionCode);
                    }
                    
                    // Post as single checkbox entry with comma-separated values.
                    // Guard against a base key that collides with a real multi-choice checkbox /
                    // checkbox-slider question: those already hold an ARRAY in surveyData and were
                    // posted correctly by the first loop. Only individual boolean toggles (scalar
                    // values) should be regrouped here — overwriting an array key would wipe the
                    // checkbox-slider's selected choices (leaving only its separately-keyed "Other"
                    // value). See Doc/PADD-3827-LinkedDemographicOtherValue.
                    for (let baseKey in groupedToggles) {
                        if (Array.isArray(surveyData?.[baseKey])) continue;
                        const value = groupedToggles[baseKey].join(','); 
                        bodyFormData.set(`_srvitem_${baseKey}`, value);
                    }
                    
                    // Remove individual toggle keys that were added by the first loop.
                    // Never delete a key that holds an array in surveyData — that is a genuine
                    // checkbox/checkbox-slider value, not an individual boolean toggle.
                    for (let key in toggleValues) {
                        if (Array.isArray(surveyData?.[key])) continue;
                        if (surveyData?.[key] !== undefined) {
                            bodyFormData.delete(`_srvitem_${key}`);
                        }
                    }
                }  
                if (dpa == null) {
                    bodyFormData.append('dpaFlag', false);
                } else {
                    bodyFormData.append('dpaFlag', isChecked);
                }
                bodyFormData.append('returnUrl', returnUrl);
                if (campaignCodeParam) {
                    bodyFormData.append('campaignCode', campaignCodeParam);
                }
           
                APIPost({
                    "controller": controller,
                    "action": "register",
                    "environment" : environment,
                    data: bodyFormData
                }).then((response) => {
                    let registerResult = response.data;
                

                    if (registerResult.success) {
                        // Registration succeeded: clear the persisted reg-form overrides
                        // so they don't carry into any later registration this session.
                        clearRegFormOverrides();
                        // Registration succeeded. Redirect back to the URL the user came from
                        // (the return URL) instead of showing a thank-you message.
                        //
                        // AFTER-rules override (post-form redirect rules): when the registration
                        // form has an "after" rule that matched, the server returns the rule's
                        // target in postformredirecturl. It takes precedence over the normal
                        // returnUrl so the user is routed to the rule destination instead.
                        let returnUrl = registerResult.postformredirecturl || auth.ReturnUrl();
                        try {
                            let returnUri = new URL(returnUrl);
                            if (returnUri.hostname != window.location.hostname && registerResult.ad_ref_token) {
                                returnUrl += (returnUrl.indexOf('?') >= 0 ? "&" : "?");
                                returnUrl += "ref=" + registerResult.ad_ref_token;
                            }
                        } catch (e) { /* returnUrl not an absolute URL — use as-is */ }

                        IsSafeUrl(returnUrl, environment).then((result) => {
                            if (result) {
                                window.location.replace(returnUrl);
                            } else {
                                if (!isNotTrusted) {
                                    setIsNotTrusted(returnUrl);
                                }
                                setButtonState("initial");
                            }
                        }).catch((errors) => {
                            setErrors(ProcessErrors(errors));
                            setButtonState("initial");
                        });
                    }
                    else {
                        setErrors(ProcessErrors(registerResult.errors));
                        setButtonState("initial")
                    }
                }).
                catch((error) => {
                    setErrors(ProcessErrors('error.unexpected'));
                    setButtonState("initial")
                });       
            }else{
                setButtonState("initial")   
            }
        }else{
            setButtonState("initial")  
        }
    }


    //when we go back to register page on pressing continue button this will get called.
    const redirect = (event) => {
        event.preventDefault();
        setButtonState("loading")
        let ad_ref_token = sessionStorage.getItem("ad_ref_token")
        //if we have ad_ref_token in the session then only we'd go further
        if (ad_ref_token) {
            let returnUrl = auth.ReturnUrl();
            let returnUri = new URL(returnUrl);
            if (returnUri.hostname != window.location.hostname) {
                if (returnUrl.indexOf('?') >= 0) {
                    returnUrl += "&";
                }
                else {
                    returnUrl += "?";
                }
                returnUrl += "ref=" + ad_ref_token;

                IsSafeUrl(returnUrl, environment).then((result) => {
                    if (result) {

                        // add adref token to returnUrl if request is from outside this host
                        navigate("/redirect", {
                            state:
                                { returnUrl: returnUrl }
                        })                         //navigate??? cause button state is an issue here. (loading)
                        setButtonState("initial")

                    }
                    else {
                        if (!isNotTrusted) {
                            setIsNotTrusted(returnUrl);
                        }
                    }
                }).catch((errors) => {
                    setErrors(ProcessErrors(errors));
                    setButtonState("initial")
                });
            }
        }
    }


    const onTextFieldKeyed = (event) => {
        if ((event.key.match(emailRegex) || []).length > 0) {
            event.preventDefault();
        }
    }


    // Prevent implicit form submission when Enter is pressed inside a single-line field.
    // The native account fields, the SurveyJS demographics form, and the Register button
    // all share ONE native <form>, so Enter in any text input would otherwise fire the
    // form's onSubmit (registering early on single-page forms, or jumping NEXT on
    // multi-page forms — which looks like the survey "reloading" to its initial state).
    //
    // This is a SaaS form — clients can add any SurveyJS question type — so the guard is
    // generic: Enter passes through for multi-line inputs (textarea / "comment" questions)
    // and rich-text editors (contenteditable) so newlines still work, and for buttons /
    // explicit submit controls. For every other single-line input we swallow Enter, which
    // matches today's native-field behavior where Enter is a no-op (click Register to submit).
    const handleFormKeyDown = (event) => {
        if (event.key !== 'Enter' || event.shiftKey) return; // Shift+Enter is always a newline
        const el = event.target;
        const tag = el?.tagName?.toLowerCase();

        // Allow newlines in multi-line / rich-text fields (any client-added comment question).
        if (tag === 'textarea') return;
        if (el?.isContentEditable) return;

        // Allow explicit submit via the Register button / submit controls.
        const type = el?.type?.toLowerCase();
        if (tag === 'button' || type === 'submit') return;

        // Everything else (single-line native + survey inputs) — block implicit submit.
        event.preventDefault();
    }


    const handleOnBlur = (e, fieldType) => {
        let value = e.target.value;
        setStateAsync(() => {
            if (value.length < 1) {
                setIsBlank(IsBlank => ({ ...IsBlank, [fieldType]: true }))
                setIsInvalid(IsInvalid => ({ ...IsInvalid, [fieldType]: false }))
            }
            else {
                setIsBlank(IsBlank => ({ ...IsBlank, [fieldType]: false }))

                //validating firstName and lastName through regex match
                if (!nameRegex.test(e.target.value)) {
                    setIsInvalid(IsInvalid => ({ ...IsInvalid, [fieldType]: true }))
                }
                else {
                    setIsInvalid(IsInvalid => ({ ...IsInvalid, [fieldType]: false }))
                }
            }
        })

    }


    //fetching frontend configurations
    const getFrontendConfiguration=()=>{
        APIGet({
           "controller": "configuration",
           "action": "frontendconfiguration",
           "environment": environment,
        }).then((response) => {
            let config= response.data.configuration
            setDpaValidationConfig(config?.dpaValidationConfiguration)

           }).catch((errors)=>{
           console.log("Error in loading frontend configuration")
         })
   }
    // Clears the persisted reg-form overrides. Called on successful registration (the
    // next login also resets them via LoginAuth's clean-slate). Kept out of the form
    // selection so a page refresh re-resolves the same form.
    const clearRegFormOverrides = () => {
        sessionStorage.removeItem("surveycode");
        sessionStorage.removeItem("friendlyUrlSlug");
        sessionStorage.removeItem("journey");
    };

    // Resolve a friendly-url slug (e.g. "2026_register") to a survey code via the
    // middleware endpoint added for this flow (Task 6). Returns null when unresolved.
    const resolveFriendlyUrl = (slug) => {
        return APIGet({
            "controller": "account",
            "action": "getformbyfriendlyurl",
            "environment": environment,
            "identifier": slug
        }).then((response) => {
            return response?.data?.success ? response.data.formId : null;
        }).catch(() => null);
    };

    // Chooses which "create account" form to show a new user, in priority order:
    //   1. ?surveycode= URL param            (Task 1)
    //   2. friendly-url slug -> survey code   (Task 1)
    //   3. checkout journey  -> brand checkout create-account form      (Task 2)
    //   4. activation journey -> brand corporate activation form         (Task 3)
    //   5. brand default 'Create account demographics' form             (Default)
    // See docs/middleware-form-selection.md.
    const getCurrentBrandDefaultDemograpicsForm = async () => {
        // 1. Explicit survey code (URL param, or persisted from the login step) wins.
        if (surveycodeURLParam) {
            setSurveyCode(surveycodeURLParam);
            return;
        }

        // 2. Friendly URL slug -> survey code.
        //    Note: the persisted overrides are intentionally NOT cleared here, so a
        //    page refresh re-resolves the same form. They are reset on the next login
        //    (LoginAuth clean-slate) and on successful registration (clearRegFormOverrides).
        if (friendlyUrlParam) {
            const resolved = await resolveFriendlyUrl(friendlyUrlParam);
            if (resolved) {
                setSurveyCode(resolved);
                return;
            }
        }

        // 3/4/5 depend on the brand's preferred-form survey codes.
        try {
            const brand = await GetCurrentBrand(environment);

            // Journey can be signalled either by the inbound ReturnUrl (checkout: /payment;
            // activation: /activation) or by an explicit login path persisted at login
            // (e.g. /{env}/login/activation -> sessionStorage 'journey').
            const checkoutJourney = isCheckoutJourney() || persistedJourney === "checkout";
            const activationJourney = isActivationJourney() || persistedJourney === "activation";

            // 3. Checkout journey.
            if (checkoutJourney && brand?.brandCheckoutCreateAccountDefaultForm) {
                setSurveyCode(brand.brandCheckoutCreateAccountDefaultForm);
                return;
            }

            // 4. Activation journey.
            if (activationJourney && brand?.brandCorporateActivationCreateAccountDefaultForm) {
                setSurveyCode(brand.brandCorporateActivationCreateAccountDefaultForm);
                return;
            }

            // 5. Default: current implementation / brand default form.
            if (brand?.brandRegistrationDemographicsDefaultForm) {
                setSurveyCode(brand.brandRegistrationDemographicsDefaultForm);
            }
        } catch (error) {
            //reject(error);
        }
    }

    const Validated = () => {
        let validated = true;
        let emailValue = userEmail;
        setIsBlank(IsBlank => ({ email: false, firstName: false, lastName: false, password: false }))
        if ((emailValue?.match(emailRegex) || []).length <= 0) {
            setIsBlank(IsBlank => ({ ...IsBlank, email: true }))
            validated &= false;
        }
        if (firstName < 1) {
            setIsBlank(IsBlank => ({ ...IsBlank, firstName: true }))
            validated &= false;
        }
        else if(!nameRegex.test(firstName)){
            setIsInvalid(IsInvalid => ({ ...IsInvalid, firstName: true }))
            validated &= false;
        }
        if (lastName < 1) {
            setIsBlank(IsBlank => ({ ...IsBlank, lastName: true }))
            validated &= false;
        }
        else if(!nameRegex.test(lastName)){
            setIsInvalid(IsInvalid => ({ ...IsInvalid, lastName: true }))
            validated &= false;
        }

        if (userPassword < 1) {
            setIsBlank(IsBlank => ({ ...IsBlank, password: true }))
            validated &= false
        }
        if (pswValid !== "true") {
            validated &= false
        }
        if (surveyRef?.current) {
            const isValid = surveyRef.current.validateSurvey();
            if (!isValid) {
                validated &= false;
            }
        }
    
        if(dpa?.questiontext && !isDpaQuestionTextBlank && dpaValidationConfig && !isChecked){
            setIsBlank(IsBlank => ({ ...IsBlank, dpa: true }))
            validated &= false
        }

        if(!validated){
            focusOnFirstError();
            }
       
        return validated;

    }

    //On submit, focusing on first error causing input field
    const focusOnFirstError = () => {
        // The error markup (invalid native inputs + .sd-question--error survey controls) is
        // added by a React re-render AFTER validation runs. On the FIRST failed submit that
        // re-render hasn't flushed yet, so a single fixed timeout queried too early and found
        // nothing — focus only landed on the SECOND click. Poll across a few animation frames
        // until the control appears, then focus it. Field-type agnostic (native inputs, survey
        // text/radio/checkbox/dropdown and the DOB date selects).
        // When two adjacent questions error at once, SurveyJS re-renders the affected rows a
        // SECOND time (via its visibleElements animation group) AFTER we first focus, remounting
        // the first field's input and dropping focus. So re-assert focus across a short window:
        // re-query the first errored control each frame and re-focus whenever focus drifts off
        // it; stop once focus holds for a couple of frames.
        const selector = "input[invalidclass='Invalid-input'], .sd-question--error input, .sd-question--error textarea, .sd-question--error select:not(.date-dropdown), .sd-question--error select.date-dropdown--error, .sd-question--error .boolean-slider-track";
        let attempts = 0;
        let stableFrames = 0;
        const maxAttempts = 45; // ~0.75s at 60fps.
        const pin = () => {
            const target = formRef.current?.querySelector(selector);
            if (target) {
                if (document.activeElement !== target) {
                    if (stableFrames === 0) {
                        target.scrollIntoView({ behavior: "smooth", block: "center" });
                    }
                    target.focus({ preventScroll: true });
                    stableFrames = 0;
                } else {
                    stableFrames++;
                }
                if (stableFrames >= 3) return;
            }
            if (attempts++ < maxAttempts) {
                requestAnimationFrame(pin);
            }
        };
        requestAnimationFrame(pin);
    };

    // Validates the native account fields (email/password/first/last). Mirrors the field
    // checks in Validated() but WITHOUT touching the embedded survey — used on the page-0
    // NEXT so the user cannot skip past the account fields into the demographics pages.
    const validateNativeFields = () => {
        let valid = true;
        setIsBlank({ email: false, firstName: false, lastName: false, password: false });
        if ((userEmail?.match(emailRegex) || []).length <= 0) {
            setIsBlank(prev => ({ ...prev, email: true })); valid = false;
        }
        if (firstName < 1) { setIsBlank(prev => ({ ...prev, firstName: true })); valid = false; }
        else if (!nameRegex.test(firstName)) { setIsInvalid(prev => ({ ...prev, firstName: true })); valid = false; }
        if (lastName < 1) { setIsBlank(prev => ({ ...prev, lastName: true })); valid = false; }
        else if (!nameRegex.test(lastName)) { setIsInvalid(prev => ({ ...prev, lastName: true })); valid = false; }
        if (userPassword < 1) { setIsBlank(prev => ({ ...prev, password: true })); valid = false; }
        if (pswValid !== "true") { valid = false; }
        if (!valid) focusOnFirstError();
        return valid;
    };

    // NEXT button for the multi-page demographics survey. Validates only the current survey
    // page (mirroring the old AD's per-page validation on NEXT); on page 0 it also validates
    // the native account fields first so they can't be skipped. SurveyJS keeps every page's
    // answers in memory, so advancing never loses data.
    const handleSurveyNext = (e) => {
        e.preventDefault();
        if (!surveyRef?.current) return;
        // PADD-3866: flag the current step in whichever indicator is showing — local state
        // drives the host-rendered page-0 indicator; setErrorStep drives the in-survey one
        // on pages 1+. Setting both keeps them consistent regardless of the current page.
        const flagError = () => {
            setErrorStep(pageNumber);
            surveyRef.current?.setErrorStep?.(pageNumber);
        };

        // Validate BOTH the native account fields (page 0 only) AND the current survey page,
        // then decide whether to block. Previously these were chained with early returns, so a
        // native-field failure short-circuited before validateCurrentPage() ever ran — which
        // meant the survey's own required questions on page 0 (which render on the SAME screen
        // as the native fields) never showed their red error state. Running both unconditionally
        // surfaces every error on the step at once, matching the single-page submit where
        // everything is validated together.
        const nativeValid = pageNumber === 0 ? validateNativeFields() : true;
        const surveyPageValid = surveyRef.current.validateCurrentPage();

        if (!nativeValid || !surveyPageValid) {
            flagError();
            focusOnFirstError();
            return;
        }
        // Advanced successfully — clear any prior error flag.
        setErrorStep(null);
        surveyRef.current?.setErrorStep?.(null);
        surveyRef.current.nextPage();
        focusFirstSurveyField();
    };

    // SurveyJS auto-focus is disabled and the native fields/Register button are hidden on
    // non-final pages, so after a page change focus is left on body and Tab jumps to the
    // footer. Poll a few frames until the new page renders, then focus its first field.
    const focusFirstSurveyField = () => {
        let tries = 0;
        const tryFocus = () => {
            const surveyRoot = formRef.current?.querySelector('.sd-page, .sv-page');
            const target = surveyRoot?.querySelector(
                'input:not([type=hidden]), select, textarea, button, [tabindex]:not([tabindex="-1"])'
            );
            if (target) { target.focus(); return; }
            if (tries++ < 10) requestAnimationFrame(tryFocus);
        };
        requestAnimationFrame(tryFocus);
    };

    // PREVIOUS never validates — the user may want to revisit earlier answers.
    const handleSurveyPrev = (e) => {
        e.preventDefault();
        if (!surveyRef?.current) return;
        surveyRef.current.prevPage();
        focusFirstSurveyField();
    };


    if (!auth.ReturnUrl() && !isLoading) {
        if (errors.length == 0) {
            errors.push('error.noreturnurl');
        }
        return (<GenericErrorBox errors={errors} />)
    }

   
    const termsText = props.brandingElement?.termsText || '';


    return (<>
        {reCaptchaError ? <RecaptchaError/>:
        (registered === "true") ?
            <div className="container" id="register-container" aria-live="polite">
                <div className="item-container">
                    <h3 className='module-heading' >{t('register.title')}</h3>
                </div>
                <div className="item-container">
                    <div className="item-wrapper">
                        <p>{t('register.thankyou', 'Thank you for registering. Your account has been created.')}</p>
                    </div>
                </div>
            </div>

            : (sessionStorage.getItem("ad_ref_token") === "null" && registered === "false") ?
      
              <div className="container register-card" id="register-container" >

                    {/* Loading spinner shown only while a survey's JSON is still loading (surveycode
                        present and not yet ready). The `register-loader` class scopes an override in
                        Register.css that centers the spinner INSIDE this card (absolute to the
                        card's relative box) instead of the viewport, without touching the shared
                        Loading / loader-wrapper styles used elsewhere. */}
                    {surveycode && !surveyReady &&
                        <Loading loading={true} class="register-loader" />
                    }

                    {/* Page title ("Create your account"). On a multi-page demographics form it
                        belongs only on the first page — from page 2 on, the survey takes over the
                        view, matching the native fields below. Single-page registration always
                        shows it.
                        When a survey is configured (surveycode present) we also hold the heading
                        back until the survey has reported ready — otherwise the default
                        "Create your account" renders first and visibly swaps to the admin-configured
                        first-page title once onReady fires. With no survey, nothing to wait for. */}
                    {!(isMultiPage && pageNumber > 0) && (!surveycode || surveyReady) &&
                    /* Wrapped in Transition so the heading fades/slides in once the title is known.
                       Everything above the fold is gated behind surveyReady, so the title, native
                       fields, survey, DPA and terms all MOUNT at the same instant (when the form
                       JSON lands). Their Transition timers are staggered into an ascending ladder
                       — title 100, email 200, password 300, name 400, survey 500, DPA 600, terms 700,
                       button 800 — so the blocks animate in one after another, top to bottom, instead
                       of popping in all at once. */
                    <Transition timer={100} mountAnimation="mount-heightAnimation">
                    <div className="item-container">
                        {/* When the form's first page has an admin-configured title (Web title),
                            that title replaces the default "Create your account" heading. This
                            applies to BOTH single-page and multi-page forms — the backend now
                            stamps the page title onto the single page too, so single-page forms
                            override the heading the same way. Forms with no first-page title keep
                            the default heading. */}
                        <h1 className='module-heading focusableHeader' tabIndex="-1" ref={headerRef}>{firstPageTitle ? firstPageTitle : t('register.title')}</h1>
                        {/* First-page description (admin-configured) shown as intro text under the
                            heading, for single-page and multi-page forms alike. Sanitized before
                            rendering since the description can contain HTML. */}
                        {firstPageDescription &&
                            <div className="module-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(firstPageDescription, { ALLOWED_ATTR: ['target', 'href', 'class', 'id', 'style'] }) }} />
                        }
                    </div>
                    </Transition>
                    }

                    {/* Step indicator (PADD-3866): on the account step (page 0) it is rendered
                        here, under the "Create your account" heading and above the native fields
                        (where an in-survey element can't reach). On the demographics pages (1..n)
                        the indicator is injected INSIDE the survey instead (stepIndicatorStartPage=1),
                        so it sits directly under each page's own title. Hidden when the form
                        branches. */}
                    {isMultiPage && !hasBranching && pageNumber === 0 &&
                    <div className="item-container">
                        <div className="item-wrapper">
                            <FormStepIndicator
                                stepCount={pageCount}
                                currentStep={pageNumber}
                                errorStep={errorStep}
                            />
                        </div>
                    </div>
                    }

                    <span aria-live="polite"><GenericErrorBox errors={errors}/></span>
                    <RedirectWarning isNotTrusted={isNotTrusted} returnUrl={isNotTrusted} />
                    <form ref={formRef} onSubmit={registerUser} onKeyDown={handleFormKeyDown} className={isNotTrusted ? "noshow" : ""}>

                        {/* Native form fields — email / password / first / last. On a multi-page
                            demographics form these belong only on the FIRST page; from page 2 on,
                            the survey takes over the view. We hide them with display:none (rather
                            than unmounting) so their values persist in the form and still submit on
                            the last page. Single-page registration always shows them.
                            When a survey is configured we also hold the native fields back until
                            the survey has reported ready (same gate as the title), so the heading
                            loads and animates in FIRST and the fields follow. No survey → render
                            immediately. */}
                        {(!surveycode || surveyReady) &&
                        <div style={{ display: (isMultiPage && pageNumber > 0) ? 'none' : undefined }}>

                        {/* Native form fields. Email sits in its own Transition (slot 200) so it
                            animates in right after the title (100) and before the password (300),
                            keeping a clean top-to-bottom cascade. */}
                        <Transition timer={200} mountAnimation="mount-heightAnimation">
                        <div className="item-container">
                            <div className="item-wrapper">
                                <InputWrapperRefacture
                                    label={t('register.emaillabel')}
                                    edit={true}
                                    route={createUrl("login")}
                                    id="email"
                                    name="email"
                                    type="email"
                                    onBlur={(e) => { handleOnBlur(e, "email") }}
                                    inputFieldType="text"
                                    btnText={t('input.edittextlabel')}
                                    invalidClass={IsBlank.email && "Invalid-input"}
                                    aria-invalid={IsBlank.email}
                                    aria-describedby="email-blank-error"
                                    inputSize="full-width"
                                    value={userEmail}
                                    onKeyPress={onTextFieldKeyed}
                                />
                                <span role="alert" id="email-blank-error">{IsBlank.email && <ErrorBoxCS>{t('register.blankemail')}</ErrorBoxCS>}</span>
                            </div>
                        </div>
                        </Transition>

                         <Transition timer={300} mountAnimation="mount-heightAnimation">
                        {/* password with validations ---component */}
                        <div className="item-container" >
                            <div className="item-wrapper">
                                <Password label={t('register.passwordlabel')}  
                                IsBlank={IsBlank} 
                                setIsBlank={setIsBlank} 
                                password={userPassword} 
                                setUserPassword={setUserPassword} 
                                pswValid={pswValid} 
                                setPswValid={setPswValid} 
                                />
                               
                            </div>
                        </div>
                        </Transition>
                        <Transition timer={400} mountAnimation="mount-heightAnimation">
                         <div className="item-container flex-row">
                            <div className="item-wrapper">

                                <InputWrapperRefacture
                                    label={t('register.firstname')}
                                    inputSize="full-width"
                                    id="firstname"
                                    inputFieldType="text"
                                    onBlur={(e) => { handleOnBlur(e, "firstName") }}
                                    specs="text_input"
                                    name="firstname"
                                    value={firstName}
                                    type="text"
                                    invalidClass={(IsBlank.firstName || IsInvalid?.firstName) && "Invalid-input"}
                                    onKeyPress={onTextFieldKeyed}
                                    aria-invalid={(IsBlank.firstName || IsInvalid?.firstName)}
                                    aria-describedby="firstname-blank-error" 
                                    onChange={(e) => { setFirstName(e.target.value) }}
                                />

                                <span role="alert" id='firstname-blank-error'>
                                    {IsBlank.firstName && <ErrorBoxCS>{t('register.blankfirstname')}</ErrorBoxCS>}
                                    {IsInvalid?.firstName && <ErrorBoxCS>{t('register.invalidfirstname')}</ErrorBoxCS>}
                                </span>
                            </div>

                      
                            <div className="item-wrapper">

                                <InputWrapperRefacture
                                    label={t('register.lastname')}
                                    inputSize="full-width"
                                    inputFieldType="text"
                                    id="lastname"
                                    onBlur={(e) => { handleOnBlur(e, "lastName") }}
                                    name="lastname"
                                    type="text"
                                    value={lastName}
                                    invalidClass={(IsBlank.lastName|| IsInvalid?.lastName) && "Invalid-input"}
                                    specs="text-input"
                                    onKeyPress={onTextFieldKeyed}
                                    aria-invalid={(IsBlank.lastName || IsInvalid?.lastName)}
                                    aria-describedby="lastname-blank-error" 
                                    onChange={(e) => { setLastName(e.target.value) }}
                                />

                                <span role="alert" id="lastname-blank-error">
                                    {IsBlank.lastName && <ErrorBoxCS>{t('register.blanklastname')}</ErrorBoxCS>}
                                    {IsInvalid?.lastName && <ErrorBoxCS>{t('register.invalidlastname')}</ErrorBoxCS>}
                                </span>
                            </div>
                        </div>
                 
                            </Transition>

                        </div>
                        }{/* end native fields wrapper */}

                            {(surveycode) && <>
                                {/* The <SurveyForm> must stay mounted from the start so it can fetch
                                    its JSON — that fetch is what flips surveyReady. We therefore must
                                    NOT key/remount or display:none this subtree (a remount would
                                    re-fetch and loop onReady forever; display:none would snap the
                                    content in with no transition). Instead it renders hidden via the
                                    mount-start class (opacity 0 / max-height 0 — no space, invisible,
                                    but still transition-able), and flips to mount-heightAnimation once
                                    surveyRevealed turns true (500ms after JSON load), so it animates in
                                    in its ladder slot — after the native fields, before the DPA. */}
                                <div className={`transition-onMount ${surveyRevealed ? 'mount-heightAnimation' : 'mount-start'}`}>
                                    <div className="item-container">
                                        <div className="item-wrapper">
                                            <SurveyForm
                                                ref={surveyRef}
                                                surveyCode={surveycode}
                                                apiGet={APIGet}
                                                hideFirstPagePanel={true}
                                                enablePaging={true}
                                                stepIndicatorStartPage={1}
                                                onReady={({ pageCount: pc, currentPageNo, hasBranching: hb, firstPageTitle: fpt, firstPageDescription: fpd }) => {
                                                    setPageCount(pc || 1);
                                                    setPageNumber(currentPageNo || 0);
                                                    setHasBranching(!!hb);
                                                    setFirstPageTitle(fpt || '');
                                                    setFirstPageDescription(fpd || '');
                                                    setSurveyReady(true);
                                                }}
                                                onPageChanged={(newPageNo) => {
                                                    setPageNumber(newPageNo);
                                                    // PADD-3866: changing page clears the error flag.
                                                    setErrorStep(null);
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                            }

                        {/* Multi-page demographics navigation. Only renders when the form has more
                            than one page; single-page registration shows no nav and the DPA +
                            Register button appear immediately (exactly as before). The NEXT button
                            is shown on every page except the last; PREVIOUS on every page except the
                            first. On the last page there is no NEXT — the DPA + Register button below
                            become the submit action. All buttons are type="button" so they never
                            trigger the native form's onSubmit. */}
                        {isMultiPage && !isLastSurveyPage &&
                            <div className="item-container">
                                <div className="item-wrapper one-row form-navigation">
                                    {pageNumber > 0 &&
                                        <Button type="button" btnType="secondary" buttonSize="full-width" onClick={handleSurveyPrev}>
                                            {t('register.previous', 'Previous')}
                                        </Button>
                                    }
                                    <Button type="button" buttonSize="full-width" onClick={handleSurveyNext}>
                                        {t('register.next', 'Next')}
                                    </Button>
                                </div>
                            </div>
                        }

                        {/* DPA + terms + Register button. On a multi-page form these only appear on
                            the last survey page (so the user can't register before completing every
                            page); on a single-page form they always show.
                            When a survey is configured they also wait for surveyReady so they join
                            the JSON-triggered cascade (slot 600 DPA / 700 terms) instead of showing
                            before the survey. No survey → render immediately as before. */}
                        {(!isMultiPage || isLastSurveyPage) && (!surveycode || surveyReady) && <>
                        <Transition timer={600} mountAnimation="mount-heightAnimation">
                        {(dpa?.questiontext && !isDpaQuestionTextBlank) && <>
                            <div className="item-container">
                                <div className="item-wrapper">
                                            <Checkbox label={<div dangerouslySetInnerHTML={{ __html: cleanDpaQuestionHtml }} />} id="dpa-checkbox" name="dpa" checked={isChecked} onChange={() => {setIsChecked(!isChecked)}} />
                                            <span role="alert" id="dpa-blank-error">
                                                {(IsBlank?.dpa && !isChecked) && <ErrorBoxCS>{t('register.blankdpa')}</ErrorBoxCS>}
                                            </span>
                                </div>

                            </div>
                        </>
                        }
                        </Transition>
                        <Transition timer={700} mountAnimation="mount-heightAnimation">
                        <div className="item-container">
                            <div className="item-separator"></div>
                        </div>
                        <div className="item-container">
                            <div className="meta">{ReactHtmlParser(termsText)} </div>
                        </div>
                        </Transition>
                      
                     
                        {/* Register button — last in the cascade (800, after the terms at 700).
                            Without this Transition the button div rendered immediately when its
                            parent block mounted (at surveyReady), so it appeared before everything
                            else. */}
                        <Transition timer={800} mountAnimation="mount-heightAnimation">
                        <div className="formControls one-row form-navigation">
                            {/* On a multi-page form, the last page keeps a PREVIOUS button next to
                                Register so the user can step back to earlier pages. type="button"
                                so it never triggers the native form submit. */}
                            {isMultiPage && pageNumber > 0 &&
                                <Button type="button" btnType="secondary" buttonSize="full-width" onClick={handleSurveyPrev}>
                                    {t('register.previous', 'Previous')}
                                </Button>
                            }
                            {buttonState === "initial" ?
                                <Button buttonSize="full-width">{t('register.registerbutton')}</Button>
                                : buttonState === "loading" &&
                                <Button isDisabled="true" hasIcon="updating" buttonSize="full-width">{t('register.registerbutton')}</Button>
                            }
                        </div>
                        </Transition>
                        </>
                        }
                   
             
                    </form>
                  

                </div>
             
                : sessionStorage.getItem("ad_ref_token") !== "null" && registered === "false" ? <Loading loading={isLoading} /> : ""
        }
        <LogWebActivity />
    </>
    );
}

